// extracted by mini-css-extract-plugin
module.exports = {"content":"page-header-module--content--35TwU","header":"page-header-module--header--3pOe-"};